export class CompleteProducts extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['header', 'indicator', 'number', 'trigger', 'bundle']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeaderHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.els.trigger.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.onTriggerClick)
    })
  }

  onTriggerClick (event) {
    const currentActiveTrigger = Array.from(this.els.trigger.elements).find(
      trigger => trigger.getAttribute('aria-current') === 'true',
    )
    const currentActiveBundle = this.els.bundle.elements.find(
      bundle => bundle.getAttribute('aria-hidden') === 'false',
    )

    const newActiveTrigger = event.currentTarget
    const newActiveBundle = this.els.bundle.elements.find(
      bundle =>
        bundle.getAttribute('data-number') ===
        newActiveTrigger.getAttribute('data-number'),
    )

    if (
      currentActiveTrigger === newActiveTrigger &&
      currentActiveBundle === newActiveBundle
    ) {
      return
    }

    currentActiveTrigger.setAttribute('aria-current', 'false')
    currentActiveBundle.setAttribute('aria-hidden', 'true')
    newActiveBundle.setAttribute('aria-hidden', 'false')

    this.els.indicator.element.textContent = newActiveTrigger.dataset.name
    this.els.number.element.textContent = newActiveTrigger.dataset.number

    this.style.setProperty(
      '--Background_Colour',
      newActiveTrigger.dataset.backgroundColour,
    )
    this.style.setProperty('--Text_Colour', newActiveTrigger.dataset.textColour)

    if (!window.BAO.MediaBreakpoints.isLg) {
      this.els.trigger?.element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }

    setTimeout(() => {
      newActiveTrigger.setAttribute('aria-current', 'true')
    }, 300)
  }

  setHeaderHeight () {
    const headerHeight = this.els.header.element.offsetHeight
    this.style.setProperty(
      '--Sticky_Benefits_Header_Height',
      `${headerHeight}px`,
    )
  }
}

if (!customElements.get('complete-products')) {
  customElements.define('complete-products', CompleteProducts)
}
